import CommonHero from 'components/common/hero'

export default function Hero() {
  const { user } = useCurrent()
  const { name, code, studioId } = useCtx('referralCode')
  const { open } = usePanel()
  const t = useI18n()
  const [success, setSuccess] = useState(false)

  const onButtonClick = async() => {
    mkt.referralClick({ code, studioId })
    if (!user) return open('auth')
    try {
      if (!success) {
        const query = `
          mutation ReferralAccept($code: String) {
            referralAccept(referralCode: $code)
          }
        `
        await request(query, { code })
      }

      setSuccess(true)
      $alert(t('page:referralCode.hero.success'))
      mkt.referralSuccess({ code })
    } catch (error) {
      if (error.code !== 'referral.noValidPhone') throw error
      open('phoneUpdate')
    }
  }

  const getCouponBlock = getCoupon({ name, onButtonClick, t })
  return (
    <>
      <CommonHero
        src={ cdn('how_to_pay/banner_top.png') }
        title={ t('page:referralCode.hero.title') }
        subtitle={ t('page:referralCode.hero.subtitle') }
      >
        <div className='hidden bg-white bg-opacity-90 w-72 p-5 shadow-md md:block lg:mr-20'>
          { getCouponBlock }
        </div>
      </CommonHero>

      <div className='bg-white'>
        <div className='container md:hidden py-12'>
          { getCouponBlock }
        </div>
      </div>
    </>
  )
}

const getCoupon = ({ name, onButtonClick, t }) => (
  <div className='py-3 max-w-[13rem] mx-auto'>
    <div className='text-xl font-bold pb-5 text-center'>
      <div className='pb-2'>{ name }</div>
      <div>{ t('page:referralCode.hero.invite') }</div>
    </div>
    <div className='pt-[1px] bg-black bg-opacity-30'/>
    <div className='flex justify-center'>
      <ul className='font-light list-disc list-inside py-5 inline-block'>
        {
          t('page:referralCode.hero.notes').map(note => <li key={ note }>{ note }</li>)
        }
      </ul>
    </div>
    <div className='mt-6' >
      <C.Button
        uid='referralCode.receive'
        onClick={ onButtonClick }
        fullWidth
      >
        { t('page:referralCode.hero.button') }
      </C.Button>
    </div>
  </div>
)
